import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const S = {};

S.HandSpan = styled.span``;

const MaskToggleLabel = styled.span`
    cursor: pointer;
    color: #004a98;
    padding-left: 0.5rem;
`;

const ShowHideMaskText = props => {
    const { text, startIndex, maskLength, id, maskCharacter } = props;
    const [showMasked, setShowMasked] = useState(false);

    const tooLong = Math.abs(startIndex) >= text?.length || Math.abs(maskLength) >= text?.length;
    let mask = maskCharacter.repeat(Math.abs(maskLength));
    let masked = maskCharacter.repeat(text?.length);
    let appended = '';
    let prepended = '';
    let endIndex;

    if (startIndex > 0 && !tooLong) {
        endIndex = startIndex + maskLength;
        masked = text?.slice(startIndex, endIndex);
        appended = text?.slice(endIndex, text.length);
        prepended = text?.slice(0, startIndex);
    } else if (startIndex < 0 && !tooLong) {
        endIndex = startIndex < 0 ? startIndex - maskLength : startIndex + maskLength;
        masked = text?.slice(startIndex, endIndex);
        prepended = text?.slice(-text.length, startIndex);
        appended = text?.slice(endIndex);
    } else if (startIndex === 0 && !tooLong) {
        masked = text?.slice(0, maskLength);
        appended = text?.slice(maskLength, text.length);
        prepended = '';
    } else {
        masked = text?.slice(0, text.length);
        appended = '';
        prepended = '';
        mask = maskCharacter.repeat(text.length);
    }

    function toggleText() {
        setShowMasked(!showMasked);
    }

    return (
        <S.HandSpan id={id} data-testid="mask-text-test-id">
            {prepended}
            {showMasked ? masked : mask}
            {appended}
            <MaskToggleLabel onClick={toggleText}>{showMasked ? 'Hide' : 'Show'}</MaskToggleLabel>
        </S.HandSpan>
    );
};

ShowHideMaskText.propTypes = {
    text: PropTypes.string.isRequired,
    startIndex: PropTypes.number,
    maskLength: PropTypes.number,
    maskCharacter: PropTypes.string,
    id: PropTypes.string,
};

ShowHideMaskText.defaultProps = {
    startIndex: 0,
    id: 'mask-text',
    maskCharacter: 'X',
    maskLength: 2,
};

export default ShowHideMaskText;
